import { render } from "./BasePage.vue?vue&type=template&id=64945af6&scoped=true"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"

import "./BasePage.vue?vue&type=style&index=0&id=64945af6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64945af6"]])

export default __exports__